"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SizedImage = void 0;
const react_1 = __importDefault(require("react"));
const buildImageUrl_1 = require("./buildImageUrl");
const styles_1 = require("./styles");
const useImageServiceHook_1 = require("../../hooks/useImageServiceHook");
const SizedImage = (_a) => {
    var _b;
    var { src, alt, width, height, handleServiceError } = _a, rest = __rest(_a, ["src", "alt", "width", "height", "handleServiceError"]);
    // const { canUseWebp, devicePixelRatio } = useAdditionalEnhancements();
    const { config } = (0, useImageServiceHook_1.useImageService)(); // Ensure the image service context is used
    const resizedImage = (0, buildImageUrl_1.buildImageUrl)({
        serviceUrl: config.serviceUrl,
        src,
        width,
        height,
        isWebpSupported: config.webpEnabled || false,
        devicePixelRatio: (_b = config.devicePixelRatio) === null || _b === void 0 ? void 0 : _b.toString()
    });
    return (react_1.default.createElement(styles_1.StyledSizedImage, Object.assign({ height: height, src: resizedImage, alt: alt, onError: handleServiceError }, rest)));
};
exports.SizedImage = SizedImage;
//# sourceMappingURL=SizedImage.js.map